import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../Assets/css/style.css";

const SelectDomain = () => {
  const [domains, setDomains] = useState([]);
  const [domainId, setDomainId] = useState("");
  const [description, setDescription] = useState("");
  const [resume, setResume] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchDomains = async () => {
      try {
        const res = await axios.get(
          // "http://localhost/qads_interview/domain/list.php",
          "https://interview.qads.co.in/qads_interview/domain/list.php",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(res.data); // optional, for debugging

        // Set domains correctly from the nested response
        setDomains(res.data.data.domains || []);
      } catch (err) {
        console.error(err);
        toast.error("Failed to load domains");
      }
    };

    fetchDomains();
  }, [token]);
  /* =============================
     SUBMIT FORM
  ============================== */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!resume) {
      toast.error("Please upload your resume");
      return;
    }

    const formData = new FormData();
    formData.append("domain_id", domainId);
    formData.append("candidate_description", description);
    formData.append("resume", resume);

    setLoading(true);

    try {
      const response = await axios.post(
        // "http://localhost/qads_interview/domain/select.php",
        "https://interview.qads.co.in/qads_interview/domain/select.php",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

      toast.success(response.data.message);

      setDomainId("");
      setDescription("");
      setResume(null);

      // 🚀 Navigate
      setTimeout(() => {
        navigate("/start");
      }, 1000);

    } catch (err) {
      if (err.response) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Server not reachable");
      }
    }

    setLoading(false);
  };

  return (
    <div className="domain-wrapper">
      <ToastContainer position="top-right" autoClose={3000} />

      <Container>
        <Row className="justify-content-center">
          <Col md="7" lg="6">
            <Card className="domain-card">
              <CardBody>
                <CardTitle tag="h3" className="text-center domain-title mb-4">
                  Select Your Interview Domain
                </CardTitle>

                <Form onSubmit={handleSubmit}>
                  <FormGroup>
                    <Label>Select Domain</Label>
                    <Input
                      type="select"
                      value={domainId}
                      onChange={(e) => setDomainId(e.target.value)}
                      required
                    >
                      <option value="">-- Choose Domain --</option>
                      {Array.isArray(domains) &&
                        domains.map((domain) => (
                          <option key={domain.id} value={domain.id}>
                            {domain.name}
                          </option>
                        ))}
                    </Input>
                  </FormGroup>

                  <FormGroup>
                    <Label>Candidate Description</Label>
                    <Input
                      type="textarea"
                      rows="4"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="Describe yourself..."
                      required
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label>Upload Resume (PDF/DOC/DOCX, Max 2MB)</Label>
                    <Input
                      type="file"
                      accept=".pdf,.doc,.docx"
                      onChange={(e) => setResume(e.target.files[0])}
                      required
                    />
                  </FormGroup>

                  <Button
                    className="theme-btn mt-3"
                    block
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner size="sm" /> Submitting...
                      </>
                    ) : (
                      "Submit Domain"
                    )}
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SelectDomain;